<template>
    <Modal @close="close">
        <transition name="fade">
            <div v-if="step == 0">
                <div class="delete-warning">
                    {{ $t('CONTENT_GDPR_REMOVE_REQUEST_TEXT') }}
                </div>
                <div class="actions">
                    <ActionButton
                        :label="$t('GDPR_CONFIRM_BUTTON')"
                        color="red"
                        :loading="loading"
                        @click="step = 1"
                    ></ActionButton>
                    <ActionButton
                        :label="$t('BUTTON_CANCEL')"
                        color="blue"
                        :loading="loading"
                        @click="close"
                    ></ActionButton>
                </div>
            </div>
            <div v-if="step == 1">
                <div class="delete-warning">
                    {{ $t('GDPR_WARNING_TEXT') }}
                </div>
                <div class="actions">
                    <ActionButton
                        :label="$t('GDPR_YES')"
                        color="red"
                        :loading="loading"
                        @click="step = 2"
                    ></ActionButton>
                    <ActionButton
                        :label="$t('BUTTON_CANCEL')"
                        color="blue"
                        :loading="loading"
                        @click="close"
                    ></ActionButton>
                </div>
            </div>
            <div v-if="step == 2">
                <div class="delete-warning">
                    {{ $t('GDPR_PASSWORD_CONFIRM') }}
                </div>
                <EditSection
                    ref="section"
                    :errors="errors"
                    :sections="removeSections"
                ></EditSection>
                <div class="actions">
                    <ActionButton
                        :label="$t('BUTTON_DELETE')"
                        materialIcon="delete"
                        color="red"
                        :loading="loading"
                        @click="submit"
                    ></ActionButton>
                    <ActionButton
                        :label="$t('BUTTON_CANCEL')"
                        color="blue"
                        :loading="loading"
                        @click="close"
                    ></ActionButton>
                </div>
            </div>
        </transition>
    </Modal>
</template>
<script>
export default {
    data() {
        return {
            errors: new this.$Errors(),
            loading: false,
            removeSections: {
                password: {
                    required: true,
                    title: this.$t('PLACEHOLDER_PASSWORD'),
                    value: '',
                    type: 'text-input',
                    key: 'password',
                    password: true
                }
            },
            step: 0
        }
    },
    methods: {
        submit() {
            if (this.loading) {
                return
            }
            let data = {}
            if (!this.$Utils.setForm(this.removeSections, data, this.errors)) {
                return
            }
            this.loading = true
            this.$api
                .remove(this.$Network.provideURL(`v1/accounts`), { data: data })
                .then(() => {
                    this.$store.dispatch('resetStore')
                    this.$router.push('/')
                })
                .catch(error => {
                    this.$refs.section.error(this.removeSections.password)
                    this.loading = false
                    this.$Network.handleError(error, this.errors)
                })
        },
        close() {
            this.$emit('close')
        }
    }
}
</script>
<style lang="scss" scoped>
.delete-warning {
    font-size: 1rem;
    text-align: center;
    padding: 1rem;
}
</style>
